import { render, staticRenderFns } from "./ComissionamentoForm.vue?vue&type=template&id=ed764488"
import script from "./ComissionamentoForm.vue?vue&type=script&lang=js"
export * from "./ComissionamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports